import { SelectOption } from '@dm/core/types';
import { ProductConfig } from 'app/config/switch';

export enum DiskTypeE {
    SSD = 3,
    SSD_SED = 10,
    NVME_SSD = 14,
    NVME_SSD_SED = 16,
    SCM = 17,
    SCM_SED = 18,
    SAS = 1,
    SATA = 2,
    NL_SAS = 4,
    SAS_SED = 8,
    SATA_SED = 9,
    NL_SAS_SED = 11,
    PHONY_CAPACITY_OPTIMIZED_SSD = 19,
    PHONY_CAPACITY_OPTIMIZED_SSD_SED = 20,
    CAPACITY_OPTIMIZED_SSD = 21,
    CAPACITY_OPTIMIZED_SSD_SED = 22,
}

/**
 *  独占一行显示的硬盘（盘和对应的SED盘）
 */
export const ExclusivelyOneRowShowDisk: DiskTypeE[] = [
    DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD,
    DiskTypeE.CAPACITY_OPTIMIZED_SSD,
    DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED,
    DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED,
];

// 盘类型ID--->盘类型映射
export const DiskTypeM: Map<string, string> = new Map([
    [String(DiskTypeE.SSD), 'SSD'],
    [String(DiskTypeE.SSD_SED), 'SSD'],
    [String(DiskTypeE.NVME_SSD), 'NVME'],
    [String(DiskTypeE.NVME_SSD_SED), 'NVME'],
    [String(DiskTypeE.SCM), 'SCM'],
    [String(DiskTypeE.SCM_SED), 'SCM'],
    [String(DiskTypeE.SAS), 'SAS'],
    [String(DiskTypeE.SAS_SED), 'SAS'],
    [String(DiskTypeE.NL_SAS), 'NL_SAS'],
    [String(DiskTypeE.NL_SAS_SED), 'NL_SAS'],
    [String(DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD), 'PHONY_CAPACITY_OPTIMIZED_SSD'],
    [String(DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED), 'PHONY_CAPACITY_OPTIMIZED_SSD'],
    [String(DiskTypeE.CAPACITY_OPTIMIZED_SSD), 'CAPACITY_OPTIMIZED_SSD'],
    [String(DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED), 'CAPACITY_OPTIMIZED_SSD'],
]);

// 加密 & 非加密 名称映射（配置底层返回的diskType类型）
export const DiskTypeNamePair: Map<string, string> = new Map([
    ['SSD', 'SSD_SED'],
    ['SSD_SED', 'SSD'],
    ['SCM', 'SCM_SED'],
    ['SCM_SED', 'SCM'],
    ['NVME_SSD', 'NVME_SSD_SED'],
    ['NVME_SSD_SED', 'NVME_SSD'],
    ['SAS', 'SAS_SED'],
    ['SAS_SED', 'SAS'],
    ['NL_SAS', 'NL_SAS_SED'],
    ['NL_SAS_SED', 'NL_SAS'],
    ['Capacity-Optimized SSD', 'Capacity-Optimized SSD SED'],
    ['Capacity-Optimized SSD SED', 'Capacity-Optimized SSD'],
]);

// 加密 & 非加密 ID映射
export const DiskTypeIdPair: Map<DiskTypeE, DiskTypeE> = new Map([
    [DiskTypeE.SSD, DiskTypeE.SSD_SED],
    [DiskTypeE.SSD_SED, DiskTypeE.SSD],
    [DiskTypeE.SCM, DiskTypeE.SCM_SED],
    [DiskTypeE.SCM_SED, DiskTypeE.SCM],
    [DiskTypeE.NVME_SSD, DiskTypeE.NVME_SSD_SED],
    [DiskTypeE.NVME_SSD_SED, DiskTypeE.NVME_SSD],
    [DiskTypeE.SAS, DiskTypeE.SAS_SED],
    [DiskTypeE.SAS_SED, DiskTypeE.SAS],
    [DiskTypeE.NL_SAS, DiskTypeE.NL_SAS_SED],
    [DiskTypeE.NL_SAS_SED, DiskTypeE.NL_SAS],
    [DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD, DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED],
    [DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED, DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD],
    [DiskTypeE.CAPACITY_OPTIMIZED_SSD, DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED],
    [DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED, DiskTypeE.CAPACITY_OPTIMIZED_SSD],
]);

// 加密盘
export const EncryptDisks: DiskTypeE[] = [
    DiskTypeE.SSD_SED,
    DiskTypeE.NVME_SSD_SED,
    DiskTypeE.SAS_SED,
    DiskTypeE.NL_SAS_SED,
    DiskTypeE.SATA_SED,
    DiskTypeE.SCM_SED,
    DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED,
    DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED,
];

/*
 *  容量型硬盘
 */
export const CapacityOptimizedDsik: DiskTypeE[] = [
    DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD,
    DiskTypeE.CAPACITY_OPTIMIZED_SSD,
    DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED,
    DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED,
];

/*
 *  真的容量型盘
 */
export const CapacityOptimizedDisk: DiskTypeE[] = [
    DiskTypeE.CAPACITY_OPTIMIZED_SSD,
    DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED,
];

/**
 *  假的容量型盘
 */
export const PhonyCapacityOptimizedDisk: DiskTypeE[] = [
    DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED,
    DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD,
];

/**
 *  diskType字符串与硬盘枚举映射
 */
export const DiskTypeAndEnumMap: Map<string, DiskTypeE> = new Map([
    ['Capacity-Optimized SSD', DiskTypeE.CAPACITY_OPTIMIZED_SSD],
    ['Capacity-Optimized SSD SED', DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED],
    ['Phony Capacity-Optimized SSD', DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD],
    ['Phony Capacity-Optimized SSD SED', DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED],
]);

/**
 *  假容量型硬盘映射
 */
export const PhonyCapacityOptimizedDiskMap: Map<DiskTypeE, string> = new Map([
    [DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD, 'Phony Capacity-Optimized SSD'],
    [DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED, 'Phony Capacity-Optimized SSD SED'],
]);

export enum DiskLogicTypeE {
    /**
     * 空闲盘
     */
    Free = '1',
    /**
     * 成员盘
     */
    Member = '2',
    /**
     * 热备盘
     */
    HotSpare = '3',
    /**
     * 缓存盘
     */
    Cache = '4'
}

export const DiskTypeOpts: SelectOption[] = [
    {
        value: DiskTypeE.SSD,
        label: 'system.EnumDefine_DISK_TYPE_E_SSD',
    },
    {
        value: DiskTypeE.SSD_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_SSD_SED',
    },
    {
        value: DiskTypeE.NVME_SSD,
        label: 'system.EnumDefine_DISK_TYPE_E_NVMe_SSD',
    },
    {
        value: DiskTypeE.NVME_SSD_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_NVMe_SSD_SED',
    },
    {
        value: DiskTypeE.SCM,
        label: 'system.EnumDefine_DISK_TYPE_E_SCM',
    },
    {
        value: DiskTypeE.SCM_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_SCM_SED',
    },
    {
        value: DiskTypeE.SAS,
        label: 'system.EnumDefine_DISK_TYPE_E_SAS',
    },
    {
        value: DiskTypeE.SATA,
        label: 'system.EnumDefine_DISK_TYPE_E_SATA',
    },
    {
        value: DiskTypeE.NL_SAS,
        label: 'system.EnumDefine_DISK_TYPE_E_NLSAS',
    },
    {
        value: DiskTypeE.SAS_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_SAS_SED',
    },
    {
        value: DiskTypeE.SATA_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_SATA_SED',
    },
    {
        value: DiskTypeE.NL_SAS_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_NLSAS_SED',
    },
    {
        value: DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD,
        label: 'system.EnumDefine_DISK_TYPE_E_CapacityOptimized_SSD',
    },
    {
        value: DiskTypeE.PHONY_CAPACITY_OPTIMIZED_SSD_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_CapacityOptimized_SSD_SED',
    },
    {
        value: DiskTypeE.CAPACITY_OPTIMIZED_SSD,
        label: 'system.EnumDefine_DISK_TYPE_E_CapacityOptimized_SSD',
    },
    {
        value: DiskTypeE.CAPACITY_OPTIMIZED_SSD_SED,
        label: 'system.EnumDefine_DISK_TYPE_E_CapacityOptimized_SSD_SED',
    },
];

/**
 * 性能层配额默认最小值（TB）
 */
export const DEFAULT_MIN_QUOTA = 2;

/**
 * 闪存推荐配额最小值2TB（计算型存储4盘起配，最小值是1TB）
 * 配置文件里是GB，需要转化成TB
 */
export const MinQuota = ProductConfig.MinLogicCapacitySpecInDisklessDomain
    ? (Number(ProductConfig.MinLogicCapacitySpecInDisklessDomain) / 1024)
    : DEFAULT_MIN_QUOTA;

// 计算容量时，将小数乘以1000进行换算，提高准确性
export const CapcityFactor = 1000;
// 如果推荐值减去输入值小于1GB，直接下发推荐值，全额给客户用了
export const CapacityDeviation = 2097152;
// 新融合存储池中成员盘数不超过200块，否则点确定有高危提示
export const MaxselectedDisk = 200;


export const HddSasDisks: DiskTypeE[] = [
    DiskTypeE.SAS_SED,
    DiskTypeE.NL_SAS_SED,
    DiskTypeE.SAS,
    DiskTypeE.NL_SAS,
];
export const SasDisks: DiskTypeE[] = [
    DiskTypeE.SAS,
    DiskTypeE.SAS_SED,
];
export const NlSasDisks: DiskTypeE[] = [
    DiskTypeE.NL_SAS_SED,
    DiskTypeE.NL_SAS,
];

/**
 * 存储池创建-可选控制框上限默认值
 */
export const MAX_ENG_NUM_PER_DISK_POOL_DEFAULT_VAL = 2;
